import {
  useGetApplicableRecProgramsQuery,
  useGetApplicableTrackingSystemsQuery,
  useGetCompanyRolesQuery,
  useGetCountriesQuery,
  useGetCreditProfilesQuery,
  useGetCreditSupportUnitsQuery,
  useGetIsosQuery,
  useGetNegativePricingQuery,
  useGetOfferStatusesQuery,
  useGetPerformanceGuaranteeMethodsQuery,
  useGetPriceUnitsQuery,
  useGetProductTypesQuery,
  useGetRecDeliveryMethodologiesQuery,
  useGetReferenceUserRolesQuery,
  useGetRegulatoryStatusesQuery,
  useGetSettlementIndexesQuery,
  useGetVolumeUnitsQuery,
} from '@/store/api/referenceApi';

export const useLoadReferenceData = () => {
  useGetReferenceUserRolesQuery();
  useGetRegulatoryStatusesQuery();
  useGetCreditProfilesQuery();
  useGetCompanyRolesQuery();
  useGetCountriesQuery();
  useGetOfferStatusesQuery();
  useGetProductTypesQuery();
  useGetIsosQuery();
  useGetSettlementIndexesQuery();
  useGetNegativePricingQuery();
  useGetApplicableRecProgramsQuery();
  useGetRecDeliveryMethodologiesQuery();
  useGetPerformanceGuaranteeMethodsQuery();
  useGetApplicableTrackingSystemsQuery();
  // Loaded up front so the first grid to show a price or size doesn't render it without its unit.
  useGetPriceUnitsQuery();
  useGetVolumeUnitsQuery();
  useGetCreditSupportUnitsQuery();
};
